import checkVariableAction from "./check-variable-action";

/**
 * Replace found string in original one
 * @param {String} find
 * @param {String} string
 * @param {String} match
 * @param {MainClassProps} main
 * @returns
 */
const replaceFoundString = (find, string, match, main) => {
  return string.replace(match, checkVariableAction(find, main));
};

export default replaceFoundString;
